(() => {
  if (window.comelyMobileChat) {
    window.comelyMobileChat.sync();
    return;
  }

  const triggerSelector = '[data-comely-chat-open]';
  const readyAttribute = 'data-comely-toolbar-chat';
  const mobile = window.matchMedia('(max-width: 1024px)');
  let widget = null;
  let lastTrigger = null;
  let wasOpen = false;
  let unreadRoots = [];

  const syncUnread = () => {
    const shell = widget?.shadowRoot;
    const runtime = shell?.querySelector('shopify-agent-runtime')?.shadowRoot;
    const roots = [shell, runtime].filter(Boolean);
    if (roots.length !== unreadRoots.length || roots.some((root, index) => root !== unreadRoots[index])) {
      unreadObserver.disconnect();
      unreadRoots = roots;
      roots.forEach(root => unreadObserver.observe(root, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-label']
      }));
    }
    const indicator = (runtime || shell)?.querySelector('.activator__indicator');
    const unread = Boolean(indicator?.classList.contains('activator__indicator--active'));
    document.querySelectorAll(triggerSelector).forEach(trigger => {
      const dot = trigger.querySelector('[data-comely-chat-unread]');
      if (dot) dot.hidden = !unread;
      const description = unread && indicator.getAttribute('aria-label');
      if (description) trigger.setAttribute('aria-description', description);
      else trigger.removeAttribute('aria-description');
    });
  };
  const unreadObserver = new MutationObserver(syncUnread);

  const getNativeActivator = () => {
    const shell = widget?.shadowRoot;
    const runtime = shell?.querySelector('shopify-agent-runtime')?.shadowRoot;
    return shell?.querySelector('[part~="activator"]') || runtime?.querySelector('[part~="activator"]');
  };

  const sync = () => {
    const nextWidget = document.querySelector('shopify-chat');
    if (nextWidget !== widget) {
      widget?.removeAttribute(readyAttribute);
      stateObserver.disconnect();
      widget = nextWidget;
      wasOpen = false;
      if (widget) stateObserver.observe(widget, { attributes: true, attributeFilter: ['open'] });
    }

    const triggers = document.querySelectorAll(triggerSelector);
    const ready = Boolean(widget?.isConnected && (typeof widget.show === 'function' || getNativeActivator()));
    const open = Boolean(widget?.hasAttribute('open'));
    triggers.forEach(trigger => {
      trigger.disabled = !ready;
      trigger.setAttribute('aria-busy', String(!ready));
      trigger.setAttribute('aria-expanded', String(open));
    });
    widget?.toggleAttribute(readyAttribute, Boolean(widget?.isConnected && triggers.length > 0));
    syncUnread();

    if (wasOpen && !open && lastTrigger) {
      const trigger = lastTrigger;
      lastTrigger = null;
      requestAnimationFrame(() => {
        if (mobile.matches && trigger.isConnected && !trigger.disabled) trigger.focus({ preventScroll: true });
      });
    }
    wasOpen = open;
  };
  const stateObserver = new MutationObserver(sync);

  document.addEventListener('click', event => {
    const trigger = event.target.closest?.(triggerSelector);
    if (!trigger || trigger.disabled) return;
    sync();
    if (trigger.disabled) return;
    lastTrigger = trigger;
    try {
      widget.show();
    } catch {
      const nativeActivator = getNativeActivator();
      if (nativeActivator) nativeActivator.click();
      else lastTrigger = null;
    }
    sync();
  });

  const relevant = node => node.nodeType === 1 && (
    node.matches('shopify-chat, [data-comely-toolbar], [data-comely-chat-open]') ||
    node.querySelector('shopify-chat, [data-comely-toolbar], [data-comely-chat-open]')
  );
  const structureObserver = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(relevant))) sync();
  });
  structureObserver.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('pageshow', sync);
  window.comelyMobileChat = { sync };
  customElements.whenDefined('shopify-chat').then(sync);
  customElements.whenDefined('shopify-agent-runtime').then(syncUnread);
  sync();
})();
